
<script setup>

  import { ref } from 'vue';

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import SaveNotice from '../partials/save-notice.vue';

  import { photo4Questions } from '../stores/activity-1.js';

  import Numbers from '../components/numbers.vue';

  import TextArea from '../components/text-area.vue';

  const ready = ref( false );

  setTimeout( () => ready.value = true, 100 );

</script>

<template>

  <article>

    <div class="grid lg:grid-cols-2 min-h-view gap-12 p-6 md:p-12 lg:p-24">

      <div :class="[ 'self-center justify-self-center max-w-xl transition-[opacity,transform] duration-1000', { 'opacity-0 -translate-x-full': ! ready } ]">

        <div class="uppercase text-neutral-600 font-bold">Activity 1: Hearing All the Stories</div>

        <div class="flex items-center gap-2 mt-2">
          
          <span class="uppercase text-neutral-600 font-bold">Photo</span>

          <Numbers :current="4" :total="4" />

        </div>

        <h2 class="mt-6 pb-6 text-4xl md:text-5xl font-heading uppercase border-b-[3px] border-black">Desegregation in Action</h2>

        <p class="mt-8 leading-7 text-neutral-700">

          Under pressure from the federal government to comply with

          the 1954 desegregation laws, the Orleans Parish School Board

          in New Orleans, Louisiana required an entrance exam to attend

          the previously all white William Frantz Elementary School.

          Although other children passed the exam, only 6-year-old Ruby

          Bridges attended. The photo shows Ruby on her first day at

          her new school.

        </p>

        <p class="mt-4 leading-7 text-neutral-700">

          Study the photo and react to the discussion prompts below.

        </p>

        <figure class="lg:hidden mt-12">

          <img class="w-full" src="../images/activity-1-photo-4.jpg"

            alt="6-year-old Ruby Bridges attends her first day at her new school accompanied by three U.S. Marshalls. Each of the Marshalls are looking toward the ground and frowning. An officer seen inside the window of the building has a smile on his face." />

          <figcaption class="inline-flex p-6 italic text-sm font-bold bg-amber-300 shadow-md -translate-x-4 -translate-y-4">
            
            6-year-old Ruby Bridges attends her first day at her new school.
          
          </figcaption>

        </figure>

        <div v-for="( { id, question, answer }, index ) in photo4Questions" :key="id" class="max-w-xl mt-12">
          
          <label class="font-bold" :for="id">{{ index + 1 }}. {{ question }}</label>
        
          <TextArea :id="id" v-model="answer.value" v-slot="{ count, maxLength }">
            
            <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
          
          </TextArea>

        </div>

        <SaveNotice class="mt-12" />

        <div class="flex flex-wrap justify-between gap-6 max-w-xl mt-12">

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
              hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"
          
            to="/activity/1/photo/3">
            
            <ArrowLeftCircleIcon class="w-8" />

            <span>Back</span>
          
          </RouterLink>

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/1/review">
            
            <span>Review</span>

            <ArrowRightCircleIcon class="w-8" />
          
          </RouterLink>

        </div>

      </div>

      <div :class="[ 'hidden lg:block transition-[opacity,transform] duration-700', { 'opacity-0 translate-x-full': ! ready } ]">

        <figure class="sticky top-40">

          <img class="w-full" src="../images/activity-1-photo-4.jpg"

            alt="6-year-old Ruby Bridges attends her first day at her new school accompanied by three U.S. Marshalls. Each of the Marshalls are looking toward the ground and frowning. An officer seen inside the window of the building has a smile on his face." />

          <figcaption class="inline-flex p-6 italic text-sm font-bold bg-amber-300 shadow-md -translate-x-4 -translate-y-4">
            
            6-year-old Ruby Bridges attends her first day at her new school.
          
          </figcaption>

        </figure>

      </div>

    </div>

  </article>

</template>
